export const domain = process.env.API_HOST

export const DEVICES = {
  mobile: '(max-width: 767px)',
  xs: '(max-width: 575px)',
  sm: '(min-width: 576px)',
  md: '(min-width: 768px)',
  lg: '(min-width: 1024px)',
  xl: '(min-width: 1280px)'
}

export const FRANCHISE_LOGO_URL = '/static/svgs/franchise-logo.svg'
